import { getNow } from '@/helpers/date'
import { getParamsUrl } from '@/helpers/request'
import Repository from './Repository'

const action = 'responses'
const actionMoveResponse = 'responses/move'
const request = 'response-requests'

export default {
  postResponse(data) {
    return Repository.post(action, data)
  },
  updateResponse(id, data) {
    return Repository.put(`${action}/${id}`, data)
  },
  updateStatusResponse(id, data) {
    return Repository.post(`${action}/${id}/change-status`, data)
  },
  deleteResponse(id) {
    return Repository.delete(`${action}/${id}`)
  },
  fetchResponsesInDay(data = {}) {
    return Repository.get('pages/load-day-in-bid' + getParamsUrl(data))
  },
  fetchFlights(data = {}) {
    return Repository.get('pages/flights' + getParamsUrl(data))
  },
  fetchReports(data = {}) {
    return Repository.get('pages/bid-report-responses' + getParamsUrl(data))
  },

  // TODO проверить роуты совместно с беком и удалить/оптимизировать
  getResponses(page = 1) {
    const today = getNow('YYYY-MM-DD')
    const toExpand = ['driver', 'auto', 'master-approve']
    const params = `?expand=${toExpand.join()}&load_day_from=${today}&enablePages=1&page=${page}`

    return Repository.get(action + params)
  },
  fetchResponses(page = 1) {
    const today = getNow('YYYY-MM-DD')
    const toExpand = [
      'load-day',
      'organization',
      'driver',
      'auto',
      'bid',
      'master-approve',
      'ttn-status',
    ]
    const params = `?expand=${toExpand.join()}&load_day_from=${today}&enablePages=1&page=${page}`

    return Repository.get(action + params)
  },
  getCoords(settings = {}) {
    let params = ''

    for (let key in settings) {
      params += params ? '&' : '?'
      params += `${key}=${settings[key]}`
    }

    return Repository.get(`pages/${action}/map${params}`)
  },
  getResponsesCount() {
    const today = getNow('YYYY-MM-DD')

    return Repository.get(`${action}?enablePages=1&load_day_from=${today}`)
  },
  getResponsesLoadDay(id) {
    const toExpand = ['load-day', 'driver', 'auto', 'organization', 'bid']

    return Repository.get(
      `${action}?expand=${toExpand.join()}&load_day_id=${id}`,
    )
  },
  generateAct(id) {
    return Repository.post(`${action}/${id}/generate-act`)
  },
  downloadDriverData(search = {}) {
    let params = `?expand=load-day,driver&enablePages=0`

    for (let key in search) {
      if (!Object.prototype.hasOwnProperty.call(search, key) || !search[key]) {
        continue
      }
      params += `&${key}=${search[key]}`
    }

    return Repository.get(action + params)
  },
  getResponsesByIdsForTotalReport(reportId, page = 1) {
    const toExpand = [
      'document-status',
      'load-day',
      'organization',
      'driver',
      'auto',
      'master-approve',
      'act-status',
      'ttn-status',
      'payment-status',
    ]

    return Repository.get(
      `${action}?expand=${toExpand.join()}&report_id=${reportId}&enablePages=1&page=${page}&perPage=10`,
    )
  },
  getResponsesByIdsForTotalReportNotAdded(ids, page = 1) {
    const toExpand = [
      'document-status',
      'load-day',
      'organization',
      'driver',
      'auto',
      'master-approve',
      'act-status',
      'ttn-status',
      'payment-status',
    ]

    return Repository.get(
      `${action}?expand=${toExpand.join()}&id=${ids}&enablePages=1&page=${page}&perPage=10`,
    )
  },
  setNewDay(data) {
    return Repository.post(`${actionMoveResponse}`, data)
  },

  getStatisticByLogist(settings) {
    let params = getParamsUrl(settings)

    return Repository.get(`${action}/manager-payment-stats${params}`)
  },

  // работа с заявками на респонс
  postResponseRequest(data) {
    return Repository.post(request + '/create', data)
  },

  // запрос на список респонсов и заявок на респонс пользователя (рейсов)
  getFlights(params) {
    return Repository.get('pages/user-flights' + params)
  },
  // запрос детальной информации по заявке на респонс или полному респонсу
  getResponseOrRequest(params) {
    return Repository.get('pages/user-single-flight?' + params)
  },
  // запрос источников информации для селекта "Откуда узнали о заявке"
  getInfoSources() {
    return Repository.get('pages/info-source-types')
  },
  postResponseComment(data) {
    return Repository.post(action + '/admin-comment', data)
  },
}
